import React from "react";
import { profile, stats, services } from "../mock/mock";

const AboutSection = () => {
  return (
    <section
      id="about"
      className="relative py-24 md:py-32 border-t border-[#1f1a15]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4 reveal">
          <div className="text-[11px] mono uppercase tracking-[0.3em] text-[#f5b14e]">
            ▶ About / Side B
          </div>
          <h2
            className="mt-4 text-5xl md:text-6xl leading-[0.95]"
            style={{ fontFamily: "'Instrument Serif', serif" }}
          >
            The person <br />
            <em className="text-[#f5b14e] not-italic">behind</em> the reel.
          </h2>
        </div>

        <div className="md:col-span-8 space-y-8 reveal">
          <p className="text-lg md:text-xl text-[#f2ece1]/85 leading-relaxed max-w-2xl">
            {profile.bio}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="border-t border-[#2a221b] pt-4"
              >
                <div
                  className="text-4xl md:text-5xl font-normal text-[#f2ece1]"
                  style={{ fontFamily: "'Instrument Serif', serif" }}
                >
                  {s.value}
                </div>
                <div className="mt-1 text-[11px] mono uppercase tracking-widest text-[#f2ece1]/55">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          <div className="grid md:grid-cols-3 gap-4 pt-8">
            {services.map((s, i) => (
              <div
                key={s.title}
                className="group relative rounded-xl border border-[#2a221b] bg-[#120e0a] p-5 hover:border-[#f5b14e]/60 transition-colors"
              >
                <div className="text-[10px] mono text-[#f2ece1]/40">
                  0{i + 1} / 03
                </div>
                <div
                  className="mt-3 text-2xl"
                  style={{ fontFamily: "'Instrument Serif', serif" }}
                >
                  {s.title}
                </div>
                <div className="mt-2 text-sm text-[#f2ece1]/65 leading-relaxed">
                  {s.detail}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
